import { Pagination } from "@mui/material";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllBatchProcessedOrders } from "../../../../../api/order";
import NotFound from "../../../../../components/NotFound";
import AppLayout from "../../../../../layout/DashboardLayout";
import adminIndex from "../../../components/adminIndex.module.css";
import { orderSelector } from "../../../../../redux/slices/orderSlice";
import BatchProcessDataTable from "./components/BatchProcessDataTable";

export default function BatchProcess() {
  const { batchProcessOrders, isLoading } = useSelector(orderSelector);
  const dataFetchedRef = useRef(false);
  const dispatch = useDispatch();

  const [page, setPage] = React.useState(1);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getAllBatchProcessedOrders({ page: newPage - 1, size: 50 }));
  };

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    dispatch(getAllBatchProcessedOrders({ page: 0, size: 50 }));
  }, [dispatch]);

  return (
    <AppLayout background="#f1f1f1">
      <div className={adminIndex.page}>
      <div className={adminIndex.header}>
        <h1 className={adminIndex.title}>Batch processes</h1>
      </div>
      <div className={adminIndex.card}>
        {batchProcessOrders?.batch_processes?.length > 0 ? (
          <div style={{ width: "100%" }}>
            <BatchProcessDataTable
              orders={batchProcessOrders?.batch_processes}
            />
          </div>
        ) : (
          <NotFound
            loading={isLoading}
            margin="5%"
            content="orders"
            subContent="do not have any batch process order"
          />
        )}
        <div className={adminIndex.footer}>
          <span>
            Total: <strong>{batchProcessOrders?.total_batch_process || 0}</strong>
          </span>
          {/* <TablePagination
            component="div"
            count={batchProcessOrders?.total_batch_process || 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[1, 5, 10]}
            onRowsPerPageChange={handleChangeRowsPerPage}
          /> */}

          <Pagination
            onChange={handleChangePage}
            sx={{
              ".MuiPagination-root": {
                ".Mui-selected": {
                  backgroundColor: "#8D40FF",
                  color: "#fff",
                },
              },
            }}
            defaultPage={page}
            count={Math.ceil(batchProcessOrders?.total_batch_process / 50)}
            shape="rounded"
          />
        </div>
      </div>
      </div>
    </AppLayout>
  );
}
